import React, { useEffect, useState } from 'react';
import { IonAlert, IonAvatar, IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonNote, IonPage, IonRow, IonSegment, IonSegmentButton, IonSpinner, IonText, IonTitle, IonToast, IonToolbar } from '@ionic/react';
//import ExploreContainer from '../../components/ExploreContainer';
import { alarm, alertCircle, bonfire, briefcase, calendar, checkmarkDoneCircle, chevronForward, documentText, flag, notifications, statsChart, receipt } from 'ionicons/icons';
import { useHistory } from 'react-router';
import { observer } from 'mobx-react';
import authStore from '../../store/auth';
import WarehouseRequestList from './WarehouseRequestList';
import approvalStore from '../../store/approval';

const ListApproval: React.FC = observer(() => {
    const history = useHistory();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [showConfirm, setShowConfirm] = useState(false);
    const [isBulkApproving, setIsBulkApproving] = useState(false);

    useEffect(() => {
        authStore.checkAuth();
        approvalStore.getApprovalList();
    }, []);

    useEffect(() => {
        setSelectedIds([]);
    }, [approvalStore.approval_status_filter]);

    const isPendingTab = approvalStore.approval_status_filter === 'pending';
    const list = approvalStore.approval_data && approvalStore.approval_data.length > 0 ? approvalStore.approval_data : [];

    const handleToggleSelect = (id: string) => {
        setSelectedIds((prev) => prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]);
    };

    const handleToggleSelectAll = () => {
        setSelectedIds((prev) => prev.length === list.length ? [] : list.map((item: any) => item._id));
    };

    const handleBulkApprove = async () => {
        setIsBulkApproving(true);
        try {
            await approvalStore.approveMultiple(selectedIds);
            setSelectedIds([]);
        } finally {
            setIsBulkApproving(false);
        }
    };

    // const [requests, setRequests] = useState([
    //     {
    //         id: "1",
    //         type: "Cancel Package",
    //         requester: "Rizky - Gudang A",
    //         date: "2025-10-08 09:12",
    //         reason: "Paket double scan",
    //         status: "pending" as const,
    //     },
    //     {
    //         id: "2",
    //         type: "Adjust Stock",
    //         requester: "Dewi - Gudang B",
    //         date: "2025-10-08 10:00",
    //         reason: "Stock fisik tidak sesuai sistem",
    //         status: "approved" as const,
    //     },
    // ]);

    // const [selected, setSelected] = useState<string | null>(null);

    return (
        <IonPage>
            <IonContent fullscreen>
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonTitle>List Approval</IonTitle>
                        {/* {selected ? (
                                <>
                                    <IonButtons slot="start">
                                        <IonBackButton defaultHref="#" />
                                    </IonButtons>
                                    <IonTitle>Detail Request</IonTitle>
                                </>
                            ) : (
                                <IonTitle>Approval Center</IonTitle>
                            )} */}
                        {isPendingTab && list.length > 0 && (
                            <IonButtons slot="end">
                                <IonButton onClick={handleToggleSelectAll}>
                                    <IonLabel style={{ fontSize: 13 }}>
                                        {selectedIds.length === list.length ? 'Batal Semua' : 'Pilih Semua'}
                                    </IonLabel>
                                </IonButton>
                            </IonButtons>
                        )}
                    </IonToolbar>
                    <IonToolbar>
                        <IonSegment value={approvalStore.approval_status_filter} onIonChange={(event: any) => { approvalStore.setApprovalStatus(event?.target?.value); approvalStore.getApprovalList() }}>
                            <IonSegmentButton value="pending">
                                <IonLabel style={{ textTransform: 'none' }}>Pending</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton value="approved">
                                <IonLabel style={{ textTransform: 'none' }}>Approved</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton value="rejected">
                                <IonLabel style={{ textTransform: 'none' }}>Rejected</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton value="all">
                                <IonLabel style={{ textTransform: 'none' }}>All</IonLabel>
                            </IonSegmentButton>
                        </IonSegment>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding" style={{ '--background': '#f8f9fa' }}>
                    <WarehouseRequestList
                        data={list}
                        onSelect={(data: any) => { history.push(`/detail-approval/${data._id}`); approvalStore.setSelectedApproval(data) }}
                        selectable={isPendingTab}
                        selectedIds={selectedIds}
                        onToggleSelect={handleToggleSelect}
                    />
                </IonContent>
            </IonContent>

            {isPendingTab && selectedIds.length > 0 && (
                <IonFooter>
                    <IonToolbar>
                        <IonLabel style={{ paddingLeft: 16 }}>{selectedIds.length} dipilih</IonLabel>
                        <IonButtons slot="end" style={{ paddingRight: 8, gap: 8 }}>
                            <IonButton fill="solid" color="medium" onClick={() => setSelectedIds([])} disabled={isBulkApproving}>
                                Batal
                            </IonButton>
                            <IonButton fill="solid" color="success" onClick={() => setShowConfirm(true)} disabled={isBulkApproving}>
                                {isBulkApproving ? (
                                    <IonSpinner name="dots" />
                                ) : (
                                    <>
                                        <IonIcon icon={checkmarkDoneCircle} slot="start" />
                                        Approve Terpilih
                                    </>
                                )}
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonFooter>
            )}

            <IonAlert
                isOpen={showConfirm}
                onDidDismiss={() => setShowConfirm(false)}
                header="Konfirmasi Approve"
                message={`Approve ${selectedIds.length} pengajuan terpilih?`}
                buttons={[
                    { text: 'Batal', role: 'cancel' },
                    { text: 'Approve', handler: handleBulkApprove },
                ]}
            />

            <IonToast
                isOpen={approvalStore.success_alert_toggle}
                message="Pengajuan Terpilih Berhasil Diproses!"
                onDidDismiss={() => approvalStore.setSuccessAlertToggle(false)}
                duration={3000}
                position="top"
                color="success"
            />
        </IonPage>
    );
});

export default ListApproval;
